import Component from '../abstracts/Component';

export default class ArticleProductComponent extends Component {
  get COMPONENTNAME() {
    return 'ArticleProductComponent';
  }

  get SELECTORS() {
    return {
      main: '[data-ap-main]',
      secondary: '[data-ap-secondary]',
      details: '[data-ap-details]',
      carousel: '[data-ap-carousel]',
      ctaShow: '[data-cta-show]',
      ctaHide: '[data-cta-hide]',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.main = this.$component.querySelector(this.SELECTORS.main);
    this.secondary = this.$component.querySelector(this.SELECTORS.secondary);
    this.details = this.$component.querySelector(this.SELECTORS.details);
    this.carousel = this.$component.querySelector(this.SELECTORS.carousel);
    this.ctaShow = this.$component.querySelector(this.SELECTORS.ctaShow);
    this.ctaHide = this.$component.querySelector(this.SELECTORS.ctaHide);
  }

  toggleCarousel() {
    this.ctaShow.addEventListener('click', () => {
      this.main.classList.add('carousel');
    });
    this.ctaHide.addEventListener('click', () => {
      this.main.classList.remove('carousel');
    });
  }

  setOptions() {
    const customPaging = function(slider, i) {
      return $('<i class="icon-slider-bullet"></i><i class="icon-slider-bullet-active"></i>');
    };
    let responsiveArray = [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1.8,
        },
      },
    ];
    let options = {
      slidesToShow: 2.7,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      swipe: true,
      draggable: true,
      responsive: responsiveArray,
      prevArrow: '<button type="button" class="w__slick-prev icon-slick-prev" aria-label="previous slide" data-prev-arrow><i class="icon-slick-prev"></i></button>',
      nextArrow: '<button type="button" class="w__slick-next icon-slick-next" aria-label="next slide" data-next-arrow><i class="icon-slick-next"></i></button>',
      customPaging: customPaging,
    };
    this.initCarousel(options);
  }

  initCarousel(options) {
    $(this.carousel).on('init', () => {
      //this.animateArrows();
    });
    $(this.carousel).slick(options);
  }

  animateArrows() {
    let prevArrow = this.carousel.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener('mousedown', () => {
        prevArrow.classList.remove('transition');
      });
      prevArrow.addEventListener('click', () => {
        prevArrow.classList.add('transition');
      });
    }
    let nextArrow = this.carousel.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener('mousedown', () => {
        nextArrow.classList.remove('transition');
      });
      nextArrow.addEventListener('click', () => {
        nextArrow.classList.add('transition');
      });
    }
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(module => {
        this.setOptions();
      },
      error => {
        console.error('failed to load slick', error.stack);
      }
    );
  }

  setMargins() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      let detailsHeight = this.details.offsetHeight;
    }
  }

  render() {
    this.log('Rendering...');
    this.setMargins();
    if (this.carousel) {
      this.importSlick();
      this.toggleCarousel();
    }
  }
}
